/**
 * Configuration utilities for HWsmart Frontend
 * Provides dynamic URL detection for production/preview/development environments
 */

/**
 * Dynamically determine the backend URL based on the current domain
 * This allows the same build to work on all environments without changes
 */
export const getBackendUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL;
  if (!configuredUrl) {
    throw new Error('REACT_APP_BACKEND_URL non configurato');
  }
  return configuredUrl.replace(/\/$/, '');
};

// Export the backend URL as a constant for easy import
export const BACKEND_URL = getBackendUrl();
export const API_URL = BACKEND_URL;
export const API = BACKEND_URL;

// Log for debugging (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 Backend URL configured:', BACKEND_URL);
}
